import { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

type IProps = {
  id?: string;
  label: string;
  type?: any;
  placeholder?: string;
  errors?: any;
  isRequired?: boolean;
  defaultValue?: string | null;
  options: { label: string; value: number | string }[];
  clearIcon?: boolean;
  fieldName: string;
  onChange?: (value: string | number) => void;
};

const CommSelectField = ({
  id,
  label,
  placeholder,
  errors,
  isRequired,
  defaultValue,
  options,
  clearIcon,
  fieldName,
  onChange,
}: IProps) => {
  const [selectValue, setSelectedValue] = useState<any>(defaultValue || '');

  const handleSelectChange = (value: string | number) => {
    setSelectedValue(value);
    onChange && onChange(value);
  };

  const handleClear = () => {
    setSelectedValue('');
    onChange && onChange('');
  };

  return (
    <div>
      {/* <label htmlFor={id}>{label}</label>{' '}
      {isRequired && <span className='require'>*</span>} */}
      <div style={{ position: 'relative' }}>
        <select
          id={id}
          name={fieldName}
          value={selectValue}
          onChange={(e) => handleSelectChange(e.target.value)}
          required={isRequired}
          className='form-select'
        >
          <option disabled value=''>
            Please Select
          </option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {clearIcon && selectValue && (
          <span
            style={{
              position: 'absolute',
              right: 13,
              top: 8,
              fontSize: '16px',
              cursor: 'pointer',
            }}
            onClick={handleClear}
          >
            <RxCross2 />
          </span>
        )}
      </div>
      {errors && <div className='invalid-feedback'>{errors.message}</div>}
    </div>
  );
};

export default CommSelectField;
